import React from 'react';
import cn from 'clsx';
import PropTypes from 'prop-types';

import styles from './show-hours.scss';

function ShowHours(props) {
  const { className = '', storeHours } = props;
  const { monFriHours, satHours, sunHours } = storeHours || {};

  if (!storeHours) {
    return null;
  }

  return (
    <div className={cn(styles['container'], `show-hours ${className}`)}>
      <span className={styles['weekday-font']}>Mon-Fri:</span> {monFriHours}
      <br />
      <span className={styles['weekday-font']}>Sat:</span> {satHours}
      <br />
      <span className={styles['weekday-font']}>Sun:</span> {sunHours}
    </div>
  );
}

ShowHours.propTypes = {
  className: PropTypes.string,
  storeHours: PropTypes.shape({
    monFriHours: PropTypes.string,
    satHours: PropTypes.string,
    sunHours: PropTypes.string
  })
};

export default ShowHours;
